import * as z from "zod";
import { PPP_TYPES } from "./ppp-constants";

export const pppSchema = z.object({
  name: z.string().trim().min(2, "Name must be at least 2 characters").max(200),
  description: z.string().max(2000).optional().or(z.literal("")),
  type: z.enum(PPP_TYPES, { required_error: "Pick a type" }),
  category: z.enum(["fintech", "ai", "company"]).optional().or(z.literal("")),
  keyResultPids: z.array(z.string()).min(1, "Link at least one Key Result"),
  driUserPid: z.string().optional().or(z.literal("")),
  isConfidential: z.boolean().optional(),
  memberPids: z.array(z.string()).default([]),
});

export type PppFormValues = z.infer<typeof pppSchema>;
